(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/start.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/start.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const SearchbarSection = svs.grassroots.components.searchbar_section.SearchbarSection;
const StartInfoSection = svs.grassroots.components.start_info_section.StartInfoSection;
const SelectedReceivers = svs.grassroots.components.SelectedReceivers;
const ReceiverBottomSheet = svs.grassroots.components.receiver.ReceiverBottomSheet;
const About = svs.grassroots.components.About;
const WidgetArea = svs.grassroots.utils.WidgetArea;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams,
  useHistory = _ReactRouterDOM.useHistory;
const Start = () => {
  const newsSection = useRef(null);
  const _useParams = useParams(),
    id = _useParams.id;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    receiverId = _useState2[0],
    setReceiverId = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  const _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    receiver = _useState6[0],
    setReceiver = _useState6[1];
  const response = grassrootsQueryApi.useFetchReceiverByIdQuery(receiverId, {
    skip: receiverId === ''
  });
  const history = useHistory();
  const onOpenBottomSheetHandler = receiver => {
    setReceiver(receiver);
    setOpen(true);
  };
  const isAuthenticated = () => svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    if (id) {
      setReceiverId(id.split('-')[0]);
    }
  }, [id]);

  useEffect(() => {
    if (response.isSuccess && response.data) {
      onOpenBottomSheetHandler(response.data);
    }
  }, [response]);
  const onCloseHandler = () => {
    setOpen(false);
    history.replace('/');
  };
  return React.createElement("div", {
    className: "f-content"
  }, open && React.createElement(ReceiverBottomSheet, {
    close: onCloseHandler,
    open: open,
    receiver: receiver
  }), React.createElement(SearchbarSection, {
    openBottomSheet: onOpenBottomSheetHandler
  }), React.createElement(SelectedReceivers, {
    openBottomSheet: onOpenBottomSheetHandler
  }), (!isAuthenticated() || svs.grassroots_shared_2.data.config.isCorporateSite) && React.createElement(StartInfoSection, {
    newsSection: newsSection
  }), React.createElement("div", {
    className: "widget-area-container"
  }, React.createElement(WidgetArea, {
    areaName: "resultWidgetArea"
  })), React.createElement("div", {
    className: "widget-area-container",
    ref: newsSection
  }, React.createElement("h1", null, svs.grassroots_shared_2.data.config.newsTitle), React.createElement(WidgetArea, {
    areaName: "newsWidgetArea"
  })), React.createElement(About, null));
};
svs.grassroots.pages.Start = Start;

 })(window);